// Module
var code = "<react-component name=\"PastGradings\"></react-component>\n";
// Exports
module.exports = code;